import { IconInvestments } from '@op/opds.opux-icons/business';
import { svgComponents } from '../images';

interface DynamicElementProps {
  fileName: string;
  size?: 'default' | 'large';
}

const DynamicElement = ({
  fileName,
  size = 'default',
}: DynamicElementProps): JSX.Element => {
  const Component = svgComponents[`${fileName}.svg`];
  if (Component) {
    return (
      <Component aria-hidden="true" className={size !== 'default' ? size : undefined} />
    );
  }

  return <IconInvestments />;
};

export default DynamicElement;
